<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5
       6.5 22 12 22Z"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke="color ? color : theme === 'light' ? 'var(--color-icon)' : 'var(--color-icon)'"
    />
    <path
      d="M12 8V13"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke="color ? color : theme === 'light' ? 'var(--color-icon)' : 'var(--color-icon)'"
    />
    <path
      d="M11.9941 16H12.0031"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke="color ? color : theme === 'light' ? 'var(--color-icon)' : 'var(--color-icon)'"
    />
  </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
  },
  data() {
    return {
      isHover: false,
    };
  },
  props: {
    width: {
      type: String,
      default: '28',
    },
    height: {
      type: String,
      default: '20',
    },
    color: {
      type: String,
    },
  },
};
</script>
